import React from 'react'

import { reverse } from 'named-urls'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { Box, Divider, Paper, Typography, Button } from '@material-ui/core'

import { routes } from 'routes'
import { Permitted } from 'components/Permissions'
import { LogIconButton } from 'components/Logs'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
} from 'components/Table'
import helpers from 'helpers'
import moment from 'moment'
import usePaginationWithData from 'hooks/usePaginationWithData'

const Processing = ({ invoice, onClickVerifyOrders }) => {
  const pagination = usePaginationWithData(invoice.orders, { perPage: 5 })

  return (
    <Paper>
      <Box
        display="flex"
        p={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="h4">Processamentos</Typography>
        {!!invoice.orders.length &&
          !helpers.invoices.statusVerification.isPaid(invoice.status) && (
            <Button
              variant="outlined"
              color="primary"
              onClick={onClickVerifyOrders}
            >
              Consultar
            </Button>
          )}
      </Box>
      <Divider />
      <PerfectScrollbar>
        <Table
          emptyMessage="Não existem processamentos relacionados a esta fatura"
          noWrap
        >
          <TableHead>
            <TableRow>
              <TableCell>Identificador</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Forma de pagamento</TableCell>
              <TableCell>Data da geração</TableCell>
              <TableCell>Data de vencimento</TableCell>
              <TableCell>Código externo</TableCell>
              <TableCell align="right">Valor total</TableCell>
              <Permitted admin>
                <TableCell></TableCell>
              </Permitted>
            </TableRow>
          </TableHead>
          <TableBody>
            {invoice.orders &&
              pagination.data.map((order, index) => (
                <TableRow hover key={index}>
                  <TableCell>{order.id}</TableCell>
                  <TableCell>{helpers.orders.status(order.status)}</TableCell>
                  <TableCell>{order.paymentMethod}</TableCell>
                  <TableCell>
                    {order.createdAt
                      ? moment(order.createdAt)
                          .utc(false)
                          .format('DD/MM/YYYY')
                      : '-'}
                  </TableCell>
                  <TableCell>
                    {order.dueDate
                      ? moment(order.dueDate)
                          .utc(false)
                          .format('DD/MM/YYYY')
                      : '-'}
                  </TableCell>
                  <TableCell>{order.externalCode}</TableCell>
                  <TableCell align="right">
                    {helpers.currency(parseFloat(order.price))}
                  </TableCell>
                  <Permitted admin>
                    <TableCell>
                      <LogIconButton
                        to={reverse(routes.orders.logs, {
                          orderId: order.id,
                        })}
                      />
                    </TableCell>
                  </Permitted>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
      <Box px={2}>
        <TablePagination
          count={invoice.orders.length}
          onChangePage={pagination.handleChangePage}
          onChangeRowsPerPage={pagination.handleChangeRowsPerPage}
          page={pagination.page}
          rowsPerPage={pagination.perPage}
        />
      </Box>
    </Paper>
  )
}

export default Processing
